var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6688 1.65645H13.8037V0.18405C13.8037 0.0828224 13.7209 0 13.6197 0H12.3313C12.2301 0 12.1473 0.0828224 12.1473 0.18405V1.65645H6.25769V0.18405C6.25769 0.0828224 6.17487 0 6.07364 0H4.7853C4.68407 0 4.60125 0.0828224 4.60125 0.18405V1.65645H0.736199C0.328989 1.65645 0 1.98544 0 2.39265V17.6688C0 18.076 0.328989 18.405 0.736199 18.405H17.6688C18.076 18.405 18.405 18.076 18.405 17.6688V2.39265C18.405 1.98544 18.076 1.65645 17.6688 1.65645ZM16.7485 16.7485H1.65645V8.00617H16.7485V16.7485ZM1.65645 6.44174V3.3129H4.60125V4.4172C4.60125 4.51842 4.68407 4.60125 4.7853 4.60125H6.07364C6.17487 4.60125 6.25769 4.51842 6.25769 4.4172V3.3129H12.1473V4.4172C12.1473 4.51842 12.2301 4.60125 12.3313 4.60125H13.6197C13.7209 4.60125 13.8037 4.51842 13.8037 4.4172V3.3129H16.7485V6.44174H1.65645Z",
    fill: "#A0A3B1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.92d76015a97005854e3366457c6618cc.svg";
export { ForwardRef as ReactComponent };